import axios from "services/auth/jwt/config";

let cachedAuthorization;
let cachedRequest;

export const clearAdminAccess = () => {
  cachedAuthorization = undefined;
  cachedRequest = undefined;
};

// Share both pending and completed requests, only for the current login session.
export const getMyAccesses = () => {
  const authorization = axios.defaults.headers.common.Authorization;
  if (!authorization) {
    clearAdminAccess();
    return Promise.reject(new Error("Admin access requires a signed-in user"));
  }
  if (cachedRequest && cachedAuthorization === authorization) return cachedRequest;

  cachedAuthorization = authorization;
  const request = axios.get("/adminAccess/getMyAccess", {
    headers: { Authorization: authorization }
  }).then(({ data }) => {
    if (!data || typeof data.allAccess !== "boolean" || !Array.isArray(data.accessTypes) ||
        !data.accessTypes.every(type => typeof type === "string")) {
      throw new Error("Invalid admin access response");
    }
    return data;
  }).catch(error => {
    // A failed request can be retried without discarding a newer session's cache.
    if (cachedRequest === request) clearAdminAccess();
    throw error;
  });
  cachedRequest = request;
  return request;
};

export const hasAdminAccess = (access, type) =>
  access.allAccess || access.accessTypes.includes(type);

export const getMyAccess = type =>
  getMyAccesses().then(access => hasAdminAccess(access, type));
